export default __webpack_public_path__ + "static/media/computer3.29610c90.jpg";